import * as React from "react";
const SvgBarbell = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.945 3.22a.75.75 0 0 1 1.06 0l2.358 2.357L19.72 3.22a.75.75 0 1 1 1.06 1.06l-2.357 2.358 2.357 2.357a.75.75 0 1 1-1.06 1.06L16.833 7.17v-.001l-.002-.001-2.886-2.887a.75.75 0 0 1 0-1.06m1.885 4.95a.75.75 0 0 1 0 1.06l-6.6 6.6a.75.75 0 0 1-1.06-1.06l6.6-6.6a.75.75 0 0 1 1.06 0M3.22 13.945a.75.75 0 0 1 1.06 0l2.886 2.886.002.001.001.002 2.886 2.886a.75.75 0 1 1-1.06 1.06l-2.357-2.357L4.28 20.78a.75.75 0 0 1-1.06-1.06l2.357-2.357-2.357-2.358a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }
));
export default SvgBarbell;
